/**
 * Created by Alican Köker on 2019-04-09.
 */
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {EdisonGameConfig} from "../../EdisonGameConfig";
import {EdisonGameModuleConfig} from "../../EdisonGameModuleConfig";
import {EdisonParsedGameData} from "../../server/data/EdisonParsedGameData";

export class EdisonExtraSpinController extends WinPresentationController {

    private _meterFSReset:boolean[] = [false, false, false, false, false];
    private _freespinsLeft:number = 0;
    private _previousRoundFreespins:number = -1;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "EdisonExtraSpinController"})
    }

    protected parseFeatureGameData(data:EdisonParsedGameData):void {
        this._meterFSReset = data.meterFSReset;
        this._freespinsLeft = data.freespinsLeft;
        this._previousRoundFreespins = data.freespinsLeftBefore;
    }

    protected hasWin():boolean {
        let numberOfCapHits:number = this._meterFSReset.filter(function(x) {return x === true}).length;
        return numberOfCapHits > 0;
    }

    // play wp, MAKE SURE to run this.finish() when the presentation is completed.
    protected startWinPresentation():void {
        const featSymbolPositionsOnReel:string[] = EdisonGameModuleConfig.freespinController.checkCapHits();
        const extraSpinAnimDuration:number = 1;
        let valueToBeUpdated = this._previousRoundFreespins;

        let tl:TimelineLite = new TimelineLite();

        for(let k:number = 0; k < featSymbolPositionsOnReel.length; k++) {
            tl.add(() => {
                EdisonGameModuleConfig.freespinOverlay.resetMeterBgSequence(EdisonGameConfig.instance.FEATURE_SYMBOLS.indexOf(featSymbolPositionsOnReel[k]));
            }, k * extraSpinAnimDuration);

            let isPlusThree:boolean = featSymbolPositionsOnReel[k] === "M1" || featSymbolPositionsOnReel[k] === "M2";
            tl.add(() => {
                valueToBeUpdated += (isPlusThree ? 3 : 1);

                SlotGame.keypad.setZeroBetSpinCounter(valueToBeUpdated);
            }, k * extraSpinAnimDuration + .2);
        }

        tl.add(() => this.finish(false), featSymbolPositionsOnReel.length * extraSpinAnimDuration + 2);

        tl.add(() => {
            SlotGame.sound.fadeAmbience(1, 500);
        }, 2.5);
    }

    // stop wp, reset, finish. for both completing and aborting.
    protected stopWinPresentation(isAborted:boolean):void {

    }

    protected finish(isAborted:boolean = false):void {
        this._previousRoundFreespins = this._freespinsLeft;
        super.finish(isAborted);
    }
}